import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import FullscreenIcon from "@dcl/icons/esm/ui/fullscreen-77";
import Image from "../../elements/Image";
import Modal from "../../modules/Modal";
import rehydrator from "./Figure.rehydrator";

var Figure = /*#__PURE__*/function (_React$Component) {
  _inherits(Figure, _React$Component);

  var _super = _createSuper(Figure);

  function Figure() {
    var _this;

    _classCallCheck(this, Figure);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(Figure.displayName));

    _defineProperty(_assertThisInitialized(_this), "state", {
      modalOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseModal", function () {
      _this.setState({
        modalOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleIconClick", function (event) {
      event.preventDefault();

      _this.setState({
        modalOpen: true
      });
    });

    return _this;
  }

  _createClass(Figure, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["children"]);

      var attribution = rest.attribution,
          caption = rest.caption,
          expandable = rest.expandable,
          expandableUrl = rest.expandableUrl,
          ariaLabel = rest.ariaLabel,
          altText = rest.altText;
      var modalOpen = this.state.modalOpen;
      var rehydrationProps = {
        "data-attribution": attribution,
        "data-expandable": expandable,
        "data-expandable-url": expandableUrl
      };
      var footer;

      if (attribution) {
        footer = /*#__PURE__*/React.createElement("footer", {
          className: this.getClassName({
            descendantName: "attribution"
          })
        }, /*#__PURE__*/React.createElement("small", null, attribution));
      }

      return /*#__PURE__*/React.createElement("figure", _extends({
        className: this.getClassName()
      }, rehydrationProps, {
        "data-rehydratable": getRehydratableName(Figure.displayName)
      }), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "inner"
        })
      }, expandable && /*#__PURE__*/React.createElement("button", {
        "aria-label": ariaLabel || "Expand image",
        className: this.getClassName({
          descendantName: "expandable"
        }),
        onClick: this.handleIconClick
      }, /*#__PURE__*/React.createElement(FullscreenIcon, null)), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "imageWrapper"
        })
      }, children), footer), /*#__PURE__*/React.createElement("figcaption", {
        className: this.getClassName({
          descendantName: "caption"
        })
      }, caption), modalOpen && /*#__PURE__*/React.createElement(Modal, {
        ariaLabel: "Full screen image",
        closeLabel: "Close",
        closeThisComponent: this.handleCloseModal
      }, /*#__PURE__*/React.createElement(Figure, _extends({}, rest, {
        expandable: false
      }), expandableUrl ? /*#__PURE__*/React.createElement(Image, {
        alt: altText || "Full screen image",
        src: expandableUrl
      }) : children)));
    }
  }]);

  return Figure;
}(React.Component);

_defineProperty(Figure, "displayName", "Figure");

_defineProperty(Figure, "rehydrator", rehydrator);

export default Figure;